import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { clearPlatformToken } from "../auth";
import { platformApi } from "../api";

// Vxaro platform menu. (An item with `soon: true` renders disabled.)
const MENU = [
  { title: "Tenants", to: "/" },
  { title: "Overview", to: "/overview" },
  { title: "Agents & Releases", to: "/releases" },
  { title: "Platform Users & Roles", to: "/users" },
  { title: "Regulatory Library", to: "/regulatory" },
  { title: "Audit Log & Support Access", to: "/audit" },
  { title: "Settings", to: "/settings" },
];

export default function PlatformLayout({ children }) {
  const navigate = useNavigate();
  const [notice, setNotice] = React.useState("");
  React.useEffect(() => { platformApi.get("/platform/settings").then((r) => setNotice(r.data?.data?.values?.console_notice || "")).catch(() => {}); }, []);
  const logout = () => { clearPlatformToken(); navigate("/login"); };
  return (
    <div className="app">
      <aside className="side">
        <div className="brand">Vxaro DPDP · Platform</div>
        <nav className="sidenav">
          {MENU.map((m) => m.soon
            ? <span key={m.title} className="soon">{m.title}<em>soon</em></span>
            : <NavLink key={m.title} to={m.to} end className={({ isActive }) => (isActive ? "active" : "")}>{m.title}</NavLink>)}
        </nav>
      </aside>
      <div className="main">
        <div className="top">
          <div style={{ fontWeight: 600 }}>Platform Console</div>
          <div className="who"><button className="btn sm" onClick={logout}>Logout</button></div>
        </div>
        <div className="content">{notice && <div className="err" style={{ marginBottom: 10 }}>{notice}</div>}{children}</div>
      </div>
    </div>
  );
}
